(function(real$){'use strict';
function init(root){
  function $(arg){if(typeof arg==='function'){arg();return;}if(typeof arg==='string' && arg.charAt(0)!=='<' && arg!=='html,body'){return real$(root).find(arg).add(real$(root).filter(arg));}return real$(arg);}

$(function() {

    $('.md-home-0.md28415').each(function(i, e) {
    $(e).find('video').each(function(ii, video) {
        var src = $(video).attr('src');
        if (!src && $(video).find('source').length > 0) {
        src = $(video).find('source').attr('src')
        }
        if (src && src.indexOf(".mp4") == -1) {
        if (src.indexOf('<iframe') != -1) {
            src = $(src).attr('src')
        }
        $('<iframe frameborder="0" src="' + src + '" allowFullScrvideon="true"></iframe>').insertAfter(video)
        $(video).remove()
        }
    })
    new Swiper($(e).find('.swiper-container'), {
        observer: true,
        observeParents: true,
        speed: 1000,
        // watchOverflow: true,
        loop: true,
        slidesPerView: 1,
        parallax: true,
        pagination: {
        el: $(e).find('.swiper-pagination'),
        clickable: true,
        },
        navigation: {
        nextEl: $(this).find('.next'),
        prevEl: $(this).find('.prev'),
        },
        autoplay: {
        delay: 7000,
        disableOnInteraction: true,
        },

        on: {
        init: function() {

        },
        transitionStart: function() {
            // vidoe自动播放
            var $v = $(e).find('.swiper-slide-active video')
            $(e).find('video').each(function(i, e) {
            e.pause()
            })
            if ($v.length > 0) {
            $v.get(0).play()
            }
        },
        }
    })
    });

    $('.md28415.md-home-0 .mouse').on('click', function() {
    var height = $(this).parents('.md-home-0').height();
    $('html,body').animate({
        scrollTop: height
    }, 500)
    });

})

$(function() {

      $('.md-home-1.md28515').each(function() {
        new Swiper($(this).find('.swiper  .sco'), {
          observer: true,
          observeParents: true,
          loop: true,
          speed: 10000,
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
          slidesPerView: 4,
          spaceBetween: (30 / 1720 * 100).toFixed(2) + '%',
          freeMode: true,
          freeModeMomentum: false,

          breakpoints: {
            900: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 1.28,
              spaceBetween: 12,
            }
          }
        });
      })

    })

$(function() {

      var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      $('.md-home-2.md28517').each(function() {
        var $container = $(this);
        var swiperFlag = false;

        // 创建Swiper实例（整合原e_bannerA-2的配置）
        var swiper11 = new Swiper($container.find('.swiper .sco'), {
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 6000,
            stopOnLastSlide: false,
            disableOnInteraction: true,
          },
          speed: 1200,
          slidesPerView: 1,
          loop: true,
          navigation: {
            nextEl: $container.find('.p_btn_next')[0],
            prevEl: $container.find('.p_btn_prev')[0],
          },
          pagination: {
            el: $container.find('.p_pagenation')[0],
            clickable: true,
          },
          on: {
            init: function() {
              // 初始化时给移动端视频添加控制属性
              if (isMobile) {
                $container.find('video').prop({
                  controls: true,
                  playsinline: true
                });
              }
            },
            slideChangeTransitionEnd: function() {
              var _this = $container.find('.swiper .sco .swiper-slide').eq(this.realIndex);
              if (!swiperFlag) {
                swiperFlag = true;
              } else {
                handleVideoSlide(_this, swiper11);
              }
            }
          }
        });

        // 视频滑动处理函数
        function handleVideoSlide(_this, swiperInstance) {
          var video = _this.find('.videoContent .video')[0];
          if (!video) return;

          // 统一绑定结束事件
          $(video).off('ended').on('ended', function() {
            swiperInstance.autoplay.start();
            swiperInstance.slideNext();
          });

          if (isMobile) {
            // 移动端处理
            swiperInstance.autoplay.stop();
            $(video).off('click').on('click', function(e) {
              if (e.target.tagName === 'VIDEO') return;
              video.paused ? video.play() : video.pause();
            });

            // 监听视频操作事件
            video.addEventListener('play', () => swiperInstance.autoplay.stop());
            video.addEventListener('pause', () => swiperInstance.autoplay.start());
          } else {
            // PC端自动播放
            swiperInstance.autoplay.stop();
            video.play();
          }
        }

        // 初始化当前激活的视频
        handleVideoSlide($container.find('.swiper .sco .swiper-slide.swiper-slide-active'), swiper11);

        // 遮罩层点击播放视频（保留原功能）
        $container.find('.mask').on('click', function() {
          $(this).hide();
          $(this).parents('.video').find('.vdo')[0].play();
        });
      });

    })

$(function() {

      $('.md-home-4.md28520').each(function() {
        new Swiper($(this).find('.swiper  .sco'), {
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          slidesPerView: 4,
          spaceBetween: (30 / 1720 * 100).toFixed(2) + '%',

          breakpoints: {
            900: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 1.55,
              spaceBetween: 12,
            }
          }
        });
      })

    })



$(function() {

      f_num('.md-home-6.md28837 .num')

    })


$(function() {
    f_num('.md-about-1.md28780 .num')
    $('.md-about-2.md28780').each(function() {
        new Swiper($(this).find('.swiper  .sco'), {
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 5000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          slidesPerView: 3,
          spaceBetween: (45 / 1440 * 100).toFixed(2) + '%',

          navigation: {
            nextEl: $(this).find('.next'),
            prevEl: $(this).find('.prev'),
          },

          breakpoints: {
            900: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 1,
            },
          }
        });
      })
      $('.md-about-4.md28780').each(function() {
        new Swiper($(this).find('.swiper  .sco'), {
          observer: true,
          observeParents: true,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          slidesPerView: 3,
          navigation: {
            nextEl: $(this).find('.next'),
            prevEl: $(this).find('.prev'),
          },
          breakpoints: {
            900: {
              slidesPerView: 2,
            },
            500: {
              slidesPerView: 1,
            }
          }
        });
      })
})


$(function() {
    $('.md-product-11.md28997').each(function() {
    var swiper12 = new Swiper($(this).find('.swiper1 .sco'), {
        observer: true,
        observeParents: true,
        autoplay: false,
        slidesPerView: 'auto',
        direction: "vertical",
        watchSlidesVisibility: true,
    });
    var swiper11 = new Swiper($(this).find('.swiper2 .sco'), {
        observer: true,
        observeParents: true,
        autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
        },
        slidesPerView: 1,
        navigation: {
        nextEl: $(this).find('.next'),
        prevEl: $(this).find('.prev'),
        },
        thumbs: {
        swiper: swiper12,
        slideThumbActiveClass: 'thumb-active'
        }
    });
    })

})


// 监听输入的数量
$('.md-product-11.md28997  .nums input').on('keyup', function() {
    // let stock_num = parseInt($('#pro_number').val() || 0)//库存
    let num = parseInt($(this).val())
    if (num < 1) {
    num = 1;
    }
    $(this).val(num)
    calR($(this), num);
    calN()
})
// 增加或减少购买数量
$(".md-product-11.md28997  .nums .plus").click(function() {
    // let stock_num = parseInt($('#pro_number').val() || 0)//库存
    let num = parseInt($(this).siblings('input').val())
    // if (num >= stock_num) {
    //   hn.msg('Insufficient inventory of goods');
    //   return;
    // }
    if (num < 1) {
    num = 1
    $(this).siblings('input').val(num)
    } else {
    num++
    $(this).siblings('input').val(num)
    }
})
$(".md-product-11.md28997  .nums .minus").click(function() {
    // let stock_num = parseInt($('#pro_number').val() || 0)//库存
    let num = parseInt($(this).siblings('input').val() || 0)
    // if (num >= stock_num) {
    //   hn.msg('Insufficient inventory of goods');
    //   return;
    // }
    if (num <= 1) {
    num = 1
    $(this).siblings('input').val(num)
    } else {
    num--
    $(this).siblings('input').val(num)
    }
})

$('.md-product-11.md28997 .category [data-type] ').on('click', function() {
    $(this).addClass('selected').siblings().removeClass('selected');
    var type = $(this).attr('data-type');
    if(type===''){
        $(this).parents('.cg-item').find('.cg-top .cg-t2').text();
      }else{
        $(this).parents('.cg-item').find('.cg-top .cg-t2').text(":" + type);
      }

});
// $('.md-product-11.md28997 .category .cg-bi').on('click', function() {
//   $(this).addClass('selected').siblings().removeClass('selected');
// });

calN();
//详情
$(function() {

    $('.md28997.md-product_details1 .ns-specification').click(function() {
    if ($(this).hasClass('disabled')) {
        $('.md28997.md-product_details1 .ns-specification').removeClass('active')
        $(this).addClass('active')
    } else {
        if ($(this).hasClass('active')) {
        $(this).removeClass('active')
        } else {
        $(this).addClass('active')
        $(this).siblings().removeClass('active')
        }
    }
    set_group()
    })
    // 组合显示与隐藏
    set_group()
    var my_group = ''
    function set_group() {
    my_group = false
    $('.md28997.md-product_details1 .ns-specification.active').each(function() {
        if (!my_group) {
        my_group = $(this).attr('data-group')
        } else {
        my_group = $(this).attr('data-group') + ',' + my_group
        my_group = findDuplicates(my_group);
        my_group = my_group.join(',')
        }
    })
    if (!my_group) {
        $('.md28997.md-product_details1 .ns-specification').removeClass('disabled')

        return false
    }
    my_group = my_group.split(',');
    my_group = my_group.map(Number).filter(value => !isNaN(value));
    // console.log(my_group);
    $('.md28997.md-product_details1 .ns-specification').each(function() {
        if (checkValuesInArray($(this).attr('data-group'), my_group).length > 0 && my_group.length > 0) {
        $(this).removeClass('disabled')
        } else {
        $(this).addClass('disabled')
        $(this).removeClass('active')
        }
    })

    }
    // 获取选择的组别
    function findDuplicates(numbers) {
    var numArray = numbers.split(',').map(function(num) {
        return Number(num);
    });
    var countMap = {};
    for (var i = 0; i < numArray.length; i++) {
        var num = numArray[i];
        if (countMap[num]) {
        countMap[num] += 1;
        } else {
        countMap[num] = 1;
        }
    }
    var duplicates = [];
    for (var num in countMap) {
        if (countMap.hasOwnProperty(num) && countMap[num] > 1) {
        duplicates.push(Number(num));
        }
    }
    return duplicates;
    }
    // 判断是否存在选择的组别中
    function checkValuesInArray(csvString, targetArray) {
    var values = csvString.split(',');
    var filteredValues = [];
    for (var i = 0; i < values.length; i++) {
        var num = Number(values[i]);
        if (!isNaN(num)) {
        filteredValues.push(num);
        }
    }
    var result = [];
    for (var j = 0; j < filteredValues.length; j++) {
        var value = filteredValues[j];
        var found = false;
        for (var k = 0; k < targetArray.length; k++) {
        if (targetArray[k] === value) {
            found = true;
            break;
        }
        }
        if (found) {
        result.push(value);
        }
    }
    return result;
    }
})

//计算一行的价格，本店价*购买数量
function calR(ele, n) {
    var tr = ele.parents(".xg-item");
    var pn = parseFloat(tr.find(".pn").data('price'));
    var pt = n * pn;
    tr.find(".pt").text(pt.toFixed(2));
}

//计算被选中的商品的数量

function calN() {
    var n = 0;
    $(".xg-item").each(function() {
    var m = parseInt($(this).find(".xg-inputbox .xg-input").val());
    n = n + m;
    });
    $(".ts-tn").text(n);
}
$(function() {
    $('.md-product-12.md28997').each(function() {
    var nav = new Swiper($(this).find('.p12-nav   .sco'), {
        observer: true,
        observeParents: true,
        autoplay: false,
        slidesPerView: 'auto',
    });
    })
    $('.md-product-12.md28997 .p12-nav .nsw').on('click', function() {
    var ii = $(this).index();
    var $item = $('.md-product-12.md28997 .prc-item');
    // 示例2：滚动到指定元素位置
    $('html, body').animate({
        scrollTop: $item.eq(ii).offset().top - 100
    }, 500);
    });
    function renderStars() {
    $(' .md28997 [data-point]').each(function() {
        var $this = $(this);
        var score = Number($this.attr('data-point'));
        console.log(score);
        if (isNaN(score)) return;
        // 清空容器
        $this.empty();
        var fullStars = Math.floor(score);
        var fraction = score - fullStars;
        // 生成5颗星
        for (var i = 0; i < 5; i++) {
        var $starBox = $('<div class="star-box"></div>');
        var $starBlue = $('<div class="star-blue"></div>');
        if (i < fullStars) {
            $starBox.addClass('active');
        }
        if (i === fullStars && fraction > 0) {
            $starBlue.css('width', fraction * 100 + '%');
        }
        $starBox.append($starBlue);
        $this.append($starBox);
        }
    });
    }
    renderStars();
})

$(function() {
    $('.md-product-13.md28997').each(function() {
    new Swiper($(this).find('.swiper .sco'), {
        observer: true,
        observeParents: true,
        autoplay: {
        delay: 5000,
        stopOnLastSlide: false,
        disableOnInteraction: false
        },
        slidesPerView: 4,
        spaceBetween: (25 / 1440 * 100).toFixed(2) + '%',
        pagination: {
        el: $(this).find('.swiper-pagination'),
        clickable: true,
        },
    });
    })
})

}
real$(function(){init(document);});
document.addEventListener('shopify:section:load',function(e){init(e.target);e.target.querySelectorAll('[data-ani]').forEach(function(el){el.classList.add('ani');});});
document.addEventListener('shopify:block:select',function(e){var slide=e.target.closest('.swiper-slide');if(slide&&slide.parentElement&&slide.parentElement.parentElement.swiper){var s=slide.parentElement.parentElement.swiper;s.slideTo(Array.from(slide.parentElement.children).indexOf(slide));if(s.autoplay)s.autoplay.stop();}});
})(window.jQuery);